module.exports = __webpack_public_path__ + "static/media/gsodDown.d1550db4.svg";